import React, { useEffect, useState } from "react";
import * as THREE from "three";
import TopBackground from "./TopBackground";
import { Canvas } from "@react-three/fiber";

const MainCanvas = ({ isActive }) => {
  const [position, setPosition] = useState("absolute");

  useEffect(() => {
    if (isActive) {
      setPosition("relative");
      const mainCanvas = document.querySelector("#mainCanvas");
      const canvasChild = mainCanvas.children[0];
      canvasChild.classList.add("animate__animated", "animate__fadeIn");
      canvasChild.style.transform = "matrix(0.65, 0, 0, 0.65, 0, 0)";
    } else {
      setPosition("absolute");
    }
  }, [isActive]);

  return (
    <Canvas
      id="mainCanvas"
      onCreated={({ scene }) => {
        scene.background = new THREE.Color(0x020c1b);
      }}
      linear
      camera={{ position: [0, 0, 10], fov: 25 }}
      gl={{ antialias: true, alpha: true }}
      style={{ position: position }}
    >
      <fog attach="fog" args={["white", 50, 190]} />
      <ambientLight />
      <pointLight position={[10, 10, 10]} />
      <TopBackground />
    </Canvas>
  );
};

export default MainCanvas;
